import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { buildDynamicLinkForRef, constructArtificialLinkNode, getStaticPageLink } from "../../../../utils/links";
import Image from "../../image/Image";
import LinkWrapper from "../../linkWrapper/LinkWrapper";
import { getProductPrices } from "../../productList/utils";

const MenuCart = ({ cartData, currency, removeFromCart }) => {
    let cartTotalPrice = 0;

    return (
        <div className="shopping-cart-content">
            {cartData && cartData.length > 0 ? (
                <Fragment>
                    <ul>
                        {cartData.map((single, key) => {
                            const { discountedPrice, finalProductPrice, finalDiscountedPrice } = getProductPrices(
                                single.price,
                                single.discount,
                                currency.currencyRate,
                            );

                            discountedPrice != null
                                ? (cartTotalPrice += finalDiscountedPrice * single.quantity)
                                : (cartTotalPrice += finalProductPrice * single.quantity);

                            const productLinkNode = constructArtificialLinkNode({
                                value: buildDynamicLinkForRef("PRODUCT_DETAIL", single),
                            });

                            return (
                                <li className="single-shopping-cart" key={key}>
                                    {single.image && single.image[0] && (
                                        <div className="shopping-cart-img">
                                            <LinkWrapper linkNode={productLinkNode}>
                                                <Image imageNode={single.image[0]} className="img-fluid" />
                                            </LinkWrapper>
                                        </div>
                                    )}
                                    <div className="shopping-cart-title">
                                        <h4>
                                            <LinkWrapper linkNode={productLinkNode}>{single.displayName}</LinkWrapper>
                                        </h4>
                                        <h6>Qty: {single.quantity}</h6>
                                        <span>
                                            {discountedPrice !== null
                                                ? currency.currencySymbol + finalDiscountedPrice
                                                : currency.currencySymbol + finalProductPrice}
                                        </span>
                                        {single.selectedProductColor && single.selectedProductSize ? (
                                            <div className="cart-item-variation">
                                                <span>Color: {single.selectedProductColor}</span>
                                                <span>Size: {single.selectedProductSize}</span>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className="shopping-cart-delete">
                                        <button onClick={() => removeFromCart(single)}>
                                            <i className="fa fa-times-circle" />
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="shopping-cart-total">
                        <h4>
                            Total : <span className="shop-total">{currency.currencySymbol + cartTotalPrice.toFixed(2)}</span>
                        </h4>
                    </div>
                    <div className="shopping-cart-btn btn-hover text-center">
                        <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("CART") })} linkClass="default-btn">
                            view cart
                        </LinkWrapper>

                        <LinkWrapper
                            linkNode={constructArtificialLinkNode({ value: getStaticPageLink("CHECKOUT") })}
                            linkClass="default-btn"
                        >
                            checkout
                        </LinkWrapper>
                    </div>
                </Fragment>
            ) : (
                <p className="text-center">No items added to cart</p>
            )}
        </div>
    );
};

MenuCart.propTypes = {
    cartData: PropTypes.array,
    currency: PropTypes.object,
    removeFromCart: PropTypes.func,
};

export default MenuCart;
